import { JSX, PropsWithChildren } from 'react'

import { Body1, Heading4 } from '@ui/Typography'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

import styles from './TestStatusTemplate.module.scss'

type TestStatusTemplateBodyProps = PropsWithChildren

export const TestStatusTemplateInnerWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box flex direction='column' gap='x32'>
      {children}
    </Box>
  )
}
export const TestStatusTemplateBody: React.FC<TestStatusTemplateBodyProps> = ({ children }) => (
  <Box flex direction='column' gap='x32' className={styles.container}>
    {children}
  </Box>
)

interface TestStatusTemplateContentProps {
  title: string
  text: (string | JSX.Element)[]
}

export const TestStatusTemplateContent: React.FC<TestStatusTemplateContentProps> = ({
  title,
  text,
}) => {
  const isMobile = useWindowResize()

  return (
    <Box
      flex
      direction='column'
      gap='x16'
      align={isMobile ? 'stretch' : 'flex-start'}
      fullWidth={isMobile}
    >
      <Heading4 medium color='text-high-em'>
        {title}
      </Heading4>
      {text.map((item, index) => (
        <Body1 color='text-med-em' key={index}>
          {item}
        </Body1>
      ))}
    </Box>
  )
}

export const TestStatusTemplateActions: React.FC<PropsWithChildren> = ({ children }) => {
  const isMobile = useWindowResize()

  return (
    <Box
      flex
      direction={isMobile ? 'column' : 'row'}
      gap='x24'
      justify={isMobile ? 'stretch' : 'flex-start'}
    >
      {children}
    </Box>
  )
}
